/**
 * i18n setup pentru Private Brands.
 *
 * Strategie 2026-05-15:
 *   - 2 limbi suportate: ro (default), en
 *   - Auto-detect: order = querystring (?lang=) > localStorage > browser navigator > fallback (ro)
 *     Querystring are prioritate maximă pentru ca:
 *       a) Googlebot/crawlerele să indexeze corect URL-urile bilingue (?lang=en din sitemap)
 *       b) Userii care vin din rezultate Google EN să primească EN direct
 *   - Persistence: localStorage key "brandvis_lang"
 *   - Coverage: 19 pagini pre-login + LandingPage + blog + glosar bilingv
 */

import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import ro from './locales/ro/translation.json';
import en from './locales/en/translation.json';

// Cheie unificată pentru localStorage — alias-ul vechi (i18nextLng) cohabits OK
const LS_KEY = 'brandvis_lang';

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    debug: false,
    fallbackLng: 'ro',
    supportedLngs: ['ro', 'en'],
    nonExplicitSupportedLngs: true, // ro-RO → ro
    load: 'languageOnly', // ro-RO devine ro
    resources: {
      ro: { translation: ro },
      en: { translation: en },
    },
    interpolation: {
      escapeValue: false, // React deja escape-uiește
    },
    detection: {
      // Ordine priorităţi detection. querystring PRIMUL — esențial pentru SEO
      // (Googlebot indexeaza ?lang=en URLs ca EN, fără localStorage).
      //
      // 2026-05-17 — Scos `navigator` și `htmlTag` din lanț pentru ca platforma
      // (RO native, public țintă RO) să arate by-default română pentru orice user
      // nou (incognito, telefon EN, etc.). User-ul poate switch la EN explicit din
      // toggle-ul de limbă (salvat în localStorage) sau via ?lang=en.
      // Anterior: pe telefon setat EN, app-ul apărea în engleză din prima vizită.
      order: ['querystring', 'localStorage'],
      lookupLocalStorage: LS_KEY,
      lookupQuerystring: 'lang',
      caches: ['localStorage'],
      cookieMinutes: 60 * 24 * 365,
    },
    react: {
      useSuspense: false, // evităm Suspense pentru simplitate
    },
  });

// Sync <html lang="..."> cu limba curentă
const setHtmlLang = (lng) => {
  if (typeof document !== 'undefined' && document.documentElement) {
    document.documentElement.setAttribute('lang', lng);
  }
};
setHtmlLang(i18n.language || 'ro');
i18n.on('languageChanged', setHtmlLang);

export default i18n;
